import { useIntl } from "react-intl";

const intl = useIntl

const credentialTypes = () => {
  const credentialTypesArray = [
      {
        label: intl().formatMessage({ id: "assemble" }),
        value: "ASSEMBLE",
      },
      {
        label: intl().formatMessage({ id: "provider" }),
        value: "PROVIDER",
      },
      {
        label: intl().formatMessage({ id: "performance_security" }),
        value: "PERFORMANCE_SECURITY",
      },
      {
        label: intl().formatMessage({ id: "exhibitor" }),
        value: "EXHIBITOR",
      },
      {
        label: intl().formatMessage({ id: "assembly_disassembly_security" }),
        value: "ASSEMBLY_DISASSEMBLY_SECURITY",
      },
      {
        label: intl().formatMessage({ id: "sponsor" }),
        value: "SPONSOR",
      },
      {
        label: intl().formatMessage({ id: "services" }),
        value: "SERVICES",
      },
      {
        label: intl().formatMessage({ id: "press" }),
        value: "PRESS",
      },
      {
        label: intl().formatMessage({ id: "advisory" }),
        value: "ADVISORY",
      },
  ];

  return credentialTypesArray;
}

export default credentialTypes;
